// Tiny global mouse-activity singleton used by entity popovers.
// This way we can tell to only show (or hide) a pop over when you actually move away from it,
// not when it scrolls away automatically by other people's chat messages.
let isTracking = false;
let lastMouseMoveAt = 0;

const handleMouseMove = () => {
  lastMouseMoveAt = Date.now();
};

const ensureTracking = () => {
  if (isTracking || typeof window === 'undefined') return;
  isTracking = true;
  // Passive global listener, no rerenders.
  window.addEventListener('mousemove', handleMouseMove, { passive: true });
};

export const startPointerActivityTracking = () => {
  // Prewarm tracking so first hover after page load isn't missed.
  ensureTracking();
};

export const hasRecentMouseMove = (withinMs = 1000) => {
  // Read-only check used to decide whether hover events are "real" user motion.
  ensureTracking();
  return Date.now() - lastMouseMoveAt <= withinMs;
};
